import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import HomePageNR from './pages/homepageNR/homepageNR.component';
import SignInPage from './pages/sign-in-page/sign-in-page.component';
import SignUpPage from './pages/sign-up-page/sign-up-page.component';
//import MassesPage from './pages/masses-page/masses-page.component';
import EntryPage from './pages/entry-page/entry-page.component';
import ResetPasswordPage from './pages/reset-password-page/reset-password-page.component';
import HeaderNR from './components/headerNR/headerNR.component';
//import ClientReservationPage from './pages/client-reservations-page/client-reservations-page.component';

import { selectCurrentUser } from  './redux/user/user.selectors';
import { checkUserSession } from './redux/user/user.actions';
import { updateConfig } from './redux/mass/mass.actions';
import { firestore } from './firebase/firebase.utils';
import history from './history';





class App extends React.Component {

  unsubscribeFromAuth = null;

  componentDidMount() {

    const { checkUserSession, updateConfig } = this.props;
    checkUserSession();

    /* Get config for this app */
    let configArray = [];

    firestore.collection("globalConfig").get().then( (querySnapshot) => {
      querySnapshot.forEach((doc) => {
        configArray.push( {type: doc.id, ...doc.data()} );
      });
      updateConfig(configArray);
    
    }).catch(function(error) {
      alert("Error getting document:", error);
    });
  
  }

  componentWillUnmount() {

  }

  render() {
    return (
      <Router history={history}>
      <div> 
        <HeaderNR />
        <Switch>
          <Route exact path = '/' render={() => this.props.currentUser ? (<HomePageNR />) : (<EntryPage />) } /> 
          {/*<Route exact path ='/masses' render={() => this.props.currentUser ? (<MassesPage />) : (<SignInPage />)} />
          <Route exact path = '/reservations' render={() => this.props.currentUser ? (<ClientReservationPage/>) : (<SignInPage/>)} /> */}
          <Route exact path = '/signin' render={() => <SignInPage />} />
          <Route exact path = '/register' render={() => <SignUpPage />} />
          <Route exact path = '/resetpassword' render={() => <ResetPasswordPage />} />
          
        </Switch>
      </div>
      </Router>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser
});

const mapDispatchToProps = dispatch => ({
  checkUserSession: () => dispatch(checkUserSession()),
  updateConfig: (obj) => dispatch(updateConfig(obj))
});



export default connect(mapStateToProps, mapDispatchToProps)(App);
